import React, { useCallback, useEffect, useState } from 'react';

import {
  confirmPharmaPlanInvitation,
  getPharmaPlanInvitationPreview,
  pharmaPlanInvitationPreview,
  resetPharmaPlanInvitationPreview,
  resetStatus,
  userActions,
} from '@pharmaplan/common';
import { useNavigate, useSearchParams } from 'react-router-dom';

import OutcomeModal from '../../components/Modals/OutcomeModal';
import { Constants, OutcomeModalTypes } from '../../helpers/Constants';
import strings from '../../localization';
import { resetDialog, setDialog } from '../../reducers/dialogReducer';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';

const previewAction = userActions.getPharmaPlanInvitationPreview;
const confirmAction = userActions.confirmPharmaPlanInvitation;

const usePharmaPlanConsent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isConfirmed, setIsConfirmed] = useState(false);

  const id = searchParams.get('id');
  const preview = useAppSelector(pharmaPlanInvitationPreview);
  const handleCloseSuccess = useCallback(() => {
    dispatch(resetDialog());
  }, [dispatch]);

  useEffect(() => {
    setIsConfirmed(false);

    if (id) {
      dispatch(getPharmaPlanInvitationPreview(id));
    }

    return () => {
      dispatch(resetPharmaPlanInvitationPreview());
      dispatch(resetStatus([previewAction, confirmAction]));
      dispatch(resetDialog());
    };
  }, [dispatch, id]);

  const showConfirmationOutcome = (isPorted: boolean) => {
    dispatch(
      setDialog({
        showCloseButton: false,
        heading: { title: '' },
        Component: (
          <OutcomeModal
            type={isPorted
              ? OutcomeModalTypes.justSuccess
              : OutcomeModalTypes.error}
            message={isPorted
              ? strings.pharmaPlanConsentSuccess
              : strings.pharmaPlanConsentError}
            customClose={handleCloseSuccess}
          />
        ),
      }),
    );
  };

  const handleConfirm = async () => {
    if (!id || isConfirmed) {
      return;
    }

    const result = await dispatch(confirmPharmaPlanInvitation({
      personnelId: id,
      consent: 'true',
    }));

    if (!confirmPharmaPlanInvitation.fulfilled.match(result)) {
      return;
    }

    setIsConfirmed(true);
    showConfirmationOutcome(result.payload);
  };

  const handleNotNow = () => {
    navigate(Constants.paths.login);
  };

  return {
    preview,
    isConfirmed,
    isInvalid: !id,
    handleConfirm,
    handleNotNow,
  };
};

export default usePharmaPlanConsent;
